export function OutlineEmojiIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M8.50066 9.9984C8.77637 9.9984 8.99986 9.7749 8.99986 9.4992C8.99986 9.2235 8.77637 9 8.50066 9C8.22496 9 8.00146 9.2235 8.00146 9.4992C8.00146 9.7749 8.22496 9.9984 8.50066 9.9984Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M15.4992 9.9984C15.7749 9.9984 15.9984 9.7749 15.9984 9.4992C15.9984 9.2235 15.7749 9 15.4992 9C15.2235 9 15 9.2235 15 9.4992C15 9.7749 15.2235 9.9984 15.4992 9.9984Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M15.9983 15C15.8495 15.2016 14.4479 17.0016 11.9999 17.0016C9.55186 17.0016 8.15026 15.2016 8.00146 15"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
